import { useReplyExpertiseMeetingRequestAccessMutation } from '@/core/services/expertise-meeting'
import { getApiErrorMessage } from '@/utils/errors'
import { t } from '@lingui/macro'
import { useSnackbar } from 'notistack'
import { useCallback, useState } from 'react'

export function useReplyRequestAccess(expertiseMeetingId: string) {
  const { enqueueSnackbar } = useSnackbar()
  const [replyExpertiseMeetingRequestAccess] = useReplyExpertiseMeetingRequestAccessMutation()

  const [isAccepting, setIsAccepting] = useState(false)
  const [isDeclining, setIsDeclining] = useState(false)

  const acceptRequestAccess = useCallback(
    async (attendeeId: string) => {
      try {
        setIsAccepting(true)
        await replyExpertiseMeetingRequestAccess({ expertiseMeetingId, attendeeId, performAccept: true })
      } catch (error) {
        enqueueSnackbar(getApiErrorMessage(error, t`An error occurred while accepting the request access. Please try again!`), { variant: 'error' })
      } finally {
        setIsAccepting(false)
      }
    },
    [expertiseMeetingId, replyExpertiseMeetingRequestAccess]
  )

  const declineRequestAccess = useCallback(
    async (attendeeId: string) => {
      try {
        setIsDeclining(true)
        await replyExpertiseMeetingRequestAccess({ expertiseMeetingId, attendeeId, performAccept: false })
      } catch (error) {
        enqueueSnackbar(getApiErrorMessage(error, t`An error occurred while declining the request access. Please try again!`), { variant: 'error' })
      } finally {
        setIsDeclining(false)
      }
    },
    [expertiseMeetingId, replyExpertiseMeetingRequestAccess]
  )

  return { acceptRequestAccess, declineRequestAccess, isAccepting, isDeclining }
}
